import React, { FC, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Select, SelectProps } from '../Select/Select';
import { Unidade } from 'model/reino/Unidade';
import { UnidadesResponsaveisSelector } from 'store/UnidadesResponsaveis/UnidadesResponsaveis.selector';
import { EstadoRequisicao } from 'store/types';
import { UnidadesResponsaveisAction } from 'store/UnidadesResponsaveis/UnidadesResponsaveis.action';
import { AlertaInline } from '../AlertaInline/AlertaInline';

interface UnidadeSelectProps extends SelectProps {}


export const UnidadeSelect: FC<UnidadeSelectProps> = ({...props}) => {
  const dispatch = useDispatch();
  
  const estado = useSelector(UnidadesResponsaveisSelector.estado);
  const isCarregando = useSelector(UnidadesResponsaveisSelector.isCarregando);
  const erros = useSelector(UnidadesResponsaveisSelector.erros);
  const hasErros = useSelector(UnidadesResponsaveisSelector.hasErros);

  const unidades = useSelector(UnidadesResponsaveisSelector.unidades);
  const opcoes = unidades.map(u => createOption(u));

  useEffect(() => {
    if (estado === EstadoRequisicao.OCIOSO) {
      dispatch(UnidadesResponsaveisAction.carregar());
    }
  }, [estado, dispatch]);

  return <>
    <Select
      {...props}
      isLoading={isCarregando}
      isLoadingError={hasErros}
      placeholder="Unidade..." 
      options={opcoes}>
      { erros && <AlertaInline mensagem={erros.data?.message} /> }
    </Select>
  </>
}

function createOption(unidade: Unidade) {
  return {
    label: `${unidade.sigla} - ${unidade.nome}`,
    value: unidade.id,
    // icone: <AvatarUnidade nome={unidade.sigla} aria-hidden={true} /> 
  }
}
